
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","viewBox":"0 0 135 135"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M68 0c37.555 0 68 30.445 68 68s-30.445 68-68 68S0 105.555 0 68 30.445 0 68 0zm0 5C33.206 5 5 33.206 5 68s28.206 63 63 63 63-28.206 63-63S102.794 5 68 5zm-3.301 66.301v19.806l-7.569-7.57-9.903 9.903 7.57 7.57H34.99V81.204l7.569 7.568 9.903-9.903-7.569-7.568H64.7zm26.408 0l-7.57 7.568 9.903 9.903 7.57-7.568v19.806H81.204l7.568-7.57-9.903-9.903-7.568 7.57V71.3h19.806zm-36.31-36.31l-7.57 7.568 9.903 9.903 7.569-7.569V64.7H44.893l7.569-7.569-9.903-9.903-7.569 7.57V34.99h19.806zm46.213 0v19.805l-7.57-7.569-9.903 9.903 7.57 7.569H71.3V44.893l7.568 7.569 9.903-9.903-7.568-7.569h19.806z","fill":"currentColor"}})])])
          )
        }
      }
    